// utils/programTypes.js
export const PROGRAM_TYPES = [
  { key: "league", label: "League" },
  { key: "tournament", label: "Tournament" },

  { key: "class", label: "Class" },
  { key: "lesson", label: "Lesson" },
  { key: "clinic", label: "Clinic" },
  { key: "camp", label: "Camp" },
  { key: "training", label: "Training" },

  { key: "drop_in", label: "Drop-In" },
  { key: "open_gym", label: "Open Gym" },
  { key: "pickup", label: "Pickup / Open Play" },
  { key: "gameplay", label: "Gameplay Session" },

  { key: "club", label: "Club"},
  { key: "club_team", label: "Club Team" },
  { key: "facility_club", label: "Facility / Membership Club" },
  { key: "social_group", label: "Social Group" },
  { key: "team", label: "Team" },
  { key: "academy", label: "Academy" },

  { key: "event", label: "Event" },
  { key: "program", label: "Program" },
];

export const getProgramTypeLabel = (key = "") => {
  const match = PROGRAM_TYPES.find((type) => type.key === key);
  return match ? match.label : key;
};